import { render } from "./free-hai.vue?vue&type=template&id=6120f58b&scoped=true"
import script from "./free-hai.vue?vue&type=script&lang=js"
export * from "./free-hai.vue?vue&type=script&lang=js"

import "./free-hai.vue?vue&type=style&index=0&id=6120f58b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6120f58b"]])

export default __exports__